import type { ITGMetadata } from "@ceeferenderer/fe-renderer-sdk/model/itgMetadata.model";
import { getBrowserName } from "../utils/browserName";
import { getDeviceType } from "../utils/deviceType";
import { queryParams } from "../config/queryParams";

const locationId: string = queryParams.locationId;

const convertToTrackingTag = (metaData: ITGMetadata) => ({
  page: {
    category: {
      businessType: "resi",
      designType: "responsive",
      primaryCategory: "help & support",
      siteType: "selfservice",
      subCategory1: `store appointment`, //metaData.itgName,
    },
    codebase: {
      name: "h&s av resi",
    },
    pageInfo: {
      browserName: getBrowserName(),
      deviceType: getDeviceType(),
      language: "en",
      locationId: locationId || "",
      pageName: `resi|selfservice|help & support|store appointment|${metaData?.pageName?.toLowerCase()}`,
      screenName: metaData.pageName,
    },
  },
  schemaVersion: "0.21.1",
  user: [],
});

export const buildTrackingTag = (metaData: ITGMetadata): HTMLScriptElement => {
  const trackingTag = document.createElement("script");
  trackingTag.setAttribute("type", "tracking-data-digitalData");
  trackingTag.textContent = JSON.stringify(convertToTrackingTag(metaData));
  return trackingTag;
};
